declare var navigator: any;


//declare var swal:any;
import { environment } from 'src/environments/environment';
import * as $ from 'jquery';
import { Capacitor } from '@capacitor/core';
import { orderBy } from 'lodash';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import * as _moment from 'moment';
import { CommonapiService } from '../Service/Commonapi.service';
import Chart from 'chart.js/auto';
export class Common {
  static app_version = 8.2
  static deal_stage = [1,2,3,4,5,6,7,8,9,10,11,12]
  static HolidaySunday = "1"
  static HolidayOther  = "2"
  static LeaveOther  = "3"
  static GetPercentage_max_min(max,min){
   return Math.round( (100 * min) / max)
  }
 static showMap(lat,lng,to_lat,to_lng){
    //var url = "https://maps.google.com/?q=" + lat + "," + lng;
    var url ="https://www.google.es/maps/dir/'"+ lat +","+lng+"'/'"+ to_lat +","+to_lng+"'";
    console.log("url",url)
    //window.open(url);
 }
  static createChart(name,elemnentid,_labels,_data,_backgroundColor,_text='75%'){
    return new Chart(elemnentid, {
      type: 'doughnut', //this denotes tha type of chart
      data: {// values on X-Axis
        labels:_labels,
           datasets: [{
    label: name,
    data: _data,
    backgroundColor:_backgroundColor ,
    hoverOffset: 4
  }],
      },
      options: {
        aspectRatio:2.5, responsive: true,
        plugins: {
          legend: {
              position: 'right'
          }
      }
      },plugins: [{
        id: 'text',
        beforeDraw: function(chart:any, a, b) {
          // const ctx = chart.ctx;
          // const txt = 'Center Text';

          // //Get options from the center object in options
          // const sidePadding = 60;
          // const sidePaddingCalculated = (sidePadding / 100) * (chart.innerRadius * 2)

          // ctx.textAlign = 'center';
          // ctx.textBaseline = 'middle';
          // const centerX = ((chart.chartArea.left + chart.chartArea.right) / 2);
          // const centerY = ((chart.chartArea.top + chart.chartArea.bottom) / 2);

          // //Get the width of the string and also the width of the element minus 10 to give it 5px side padding
          // const stringWidth = ctx.measureText(txt).width;
          // const elementWidth = (chart.innerRadius * 2) - sidePaddingCalculated;

          // // Find out how much the font can grow in width.
          // const widthRatio = elementWidth / stringWidth;
          // const newFontSize = Math.floor(30 * widthRatio);
          // const elementHeight = (chart.innerRadius * 2);

          // // Pick a new font size so it will not be larger than the height of label.
          // const fontSizeToUse = Math.min(newFontSize, elementHeight);

          // ctx.font = fontSizeToUse + 'px Arial';
          // ctx.fillStyle = 'blue';

          // // Draw text in center
          // ctx.fillText('Center Text', centerX, centerY);
        }
      }]

    });
  }

  static dataURItoBlob(dataURI) {
    const byteString = window.atob(dataURI);
    const arrayBuffer = new ArrayBuffer(byteString.length);
    const int8Array = new Uint8Array(arrayBuffer);
    for (let i = 0; i < byteString.length; i++) {
    int8Array[i] = byteString.charCodeAt(i);
    }
    const blob = new Blob([int8Array], { type: 'image/jpeg' });
    return blob;
    }
  static changeToCurrency(value) {
    if(value){
      value = value.replace(/₹/, '').replace(/\,/g, '');
     // console.log('value ', value);
      if (value && !isNaN(value)) {
        let num: number = value;
        // let temp = new Intl.NumberFormat("en-IN").format(num); //inplace of en-IN you can mention your country's code
        // console.log(temp, ' temp ');
        let result:any = new Intl.NumberFormat('en-IN', {
          style: 'currency',
          currency: 'INR',
          minimumFractionDigits: 2,
        }).format(Number(num));
        // let result = '₹' + temp;
       // console.log('result ', result);
        return result;//.toFixed(2);;//.replace(/₹/, '');
      }
    }

  }

  static changeToCurrencyWithoutDecimal(value) {
    if(value){
      value = value.replace(/₹/, '').replace(/\,/g, '');
      console.log('value ', value);
      if (value && !isNaN(value)) {
        let num: number = value;
        // let temp = new Intl.NumberFormat("en-IN").format(num); //inplace of en-IN you can mention your country's code
        // console.log(temp, ' temp ');
        let result:any = new Intl.NumberFormat('en-IN', {
          style: 'currency',
          currency: 'INR',
          minimumFractionDigits: 0,
        }).format(Number(num));
        // let result = '₹' + temp;
        console.log('result ', result);
        return result;//.toFixed(2);;//.replace(/₹/, '');
      }
    }

  }


  static   AllowedDeal(obj,allowed_deal){
    let _dl=Common.JSON_copy(obj);
    let _temp=[];
    _dl.map((x)=>{
      console.log("x.current_stage",x.current_stage)
      let _l=allowed_deal.filter((y)=>{return y==x.current_deal_stage});
      if(_l.length>0){
        _temp.push(x);
      }
    })
return _temp;
}

  static getAddress(obj) {
    let address = obj.meeting_address1;

    if (obj.meeting_address2 != null && obj.meeting_address2 != '' && obj.meeting_address2 != ',') {
      address += ', ' + obj.meeting_address2;
    }

    if (obj.meeting_area != null && obj.meeting_area != '') {
      address += ', ' + obj.meeting_area;
    }
    //landmark
    if (obj.meeting_city != null && obj.meeting_city != '') {
      address += ', ' + obj.meeting_city;
    }
    if (obj.meeting_state != null && obj.meeting_state != '') {
      address += ', ' + obj.meeting_state;
    }
    if (obj.meeting_country != null && obj.meeting_country != '') {
      address += ', ' + obj.meeting_country;
    }
    //address +=  ', ' + obj.city + ', ' + obj.billing_state + ', ' + obj.billing_country;

    return address;
  }
  static ISO_showNewDate(date) {

    return new Date(Date.parse(date));
  }

  static scrolldisable(id, flag) {
    if (flag) {
      $('#' + id).css('overflow-y', 'hidden');
    } else {
      $('#' + id).css('overflow-y', 'auto');
    }
  }
  static Call_page_msg_with_footer() {
    if (this.isDevice) {
      setTimeout(() => {
        $('#divmsgwndw').css('height', ($(window).height() - ($("#div_msg_head_card").height())) + 'px');
      });
    }

    // Common.ShowBottom(true);
  }
  static getPlatform() {
    let platformid = 0;
    if (Capacitor.getPlatform() === 'web') {
      platformid = 1;
    } else if (Capacitor.getPlatform() == "android") {
      platformid = 2;
    } else if (Capacitor.getPlatform() == "ios") {
      platformid = 3;
    }

    return platformid;
  }
  static getisDevice() {
    let platformid = 1;
    if (Capacitor.getPlatform() === 'web') {
      platformid = 2;
    }
    return platformid;
  }

  static getSectionName(id) {
    let _section_name = "";
    if (id == 1) {
      _section_name = "Tiny DOTS";
    } else if (id == 2) {
      _section_name = "Little DOTS";
    } else if (id == 3) {
      _section_name = "Big DOTS";
    }
    return _section_name;
  }
  static callColour(index: any) {

    let cls: any = "";
    switch (index % 10) {
      case 9: cls = "#8AB92A"; break;
      case 8: cls = "#086A87"; break;
      case 7: cls = "#0068B4"; break;
      case 6: cls = "#443A8F"; break;
      case 5: cls = "#B71B81"; break;
      case 4: cls = "#E82626"; break;
      case 3: cls = "#F36814"; break;
      case 2: cls = "#FFA600"; break;
      case 1: cls = "#8AB92A"; break;
      case 0: cls = "#13A29F"; break;
    }
    return cls;
  }
  static getacronym(txt) {
    if (txt && txt.length >= 2) {

      let _v = txt.split(' ')[1];

      if (_v.length >= 2) {
        _v = _v.substring(0, 2);
      } else {
        _v = _v.charAt(0)
      }
      txt = txt.charAt(0) + ((txt.split(' ')[1]) ? _v : txt.charAt(txt.length - 1));

      //txt=  txt.charAt(0)+( (txt.split(' ')[1]) ? ( ? txt.split(' ')[1] :  (txt.charAt(txt.length-1))  ) : (txt.charAt(txt.length-1)));
      if (txt.length >= 2) {
        txt = txt.substring(0, 2);
      }

      txt = txt.toUpperCase();
    }
    return txt;
  }






  async GetShareLink(resource_id: any) {
    await this.apiService.apiPost(false, 'external/get-share-link', resource_id, false)
      .then((data) => {
        return data;
      })
  }

  constructor(private router: Router, public apiService: CommonapiService) { }

  static GetPath(file_path) {
    return file_path + "".includes("http") ? file_path : "assets/images/resource/" + file_path;
  }
  static _orderBy = orderBy
  static Call_page_without_footer() {
    Common.Set_height(); Common.ShowBottom(false);
  }
  static Call_page_with_footer() {
    Common.Set_height_with_footter(); Common.ShowBottom(true);
  }
  static JSON_copy(j) {
    return JSON.parse(JSON.stringify(j));
  }
  static allowed_ext = ["docm", "svg", "jpg", "jpeg", "png", "doc", "docx", "aac", "mp3", "rar", "zip", "xlsx", "xlx", "pdf", "webp"
    , "wav", "xlsm", "xlsb", "xltx", "ppt", "pptx", "avi", "mp4", "rar"]
  static GetIcon(fname, org_img = false) {
    let dd = "";
    let ext = fname.split('.').pop().toLowerCase();
    if (ext == "jpg" || ext == "jpeg" || ext == "png" || ext == "svg" || ext == "webp") {
      if (org_img)
        dd = fname;
      else
        dd = "assets/images/extension/image.png";
    } else if (ext == "doc" || ext == "docx" || ext == "docm") {
      dd = "assets/images/extension/word.png";
    }
    else if (ext == "aac" || ext == "mp3" || ext == "wav") {
      dd = "assets/images/extension/music.png";
    } else if (ext == "rar" || ext == "zip") {
      dd = "assets/images/extension/zip.png";
    }
    else if (ext == "xlsx" || ext == "xlsm" || ext == "xlsb" || ext == "xltx") {
      dd = "assets/images/extension/excel.png";
    }
    else if (ext == "ppt" || ext == "pptx") {
      dd = "assets/images/extension/powerpoint.png"
    }
    else if (ext == "avi" || ext == "mp4") {
      dd = "assets/images/extension/video.png"
    }
    else if (ext == "pdf") {
      dd = "assets/images/extension/pdf.png"
    } else {
      dd = "assets/images/extension/image.png"
    }
    return dd;
  }
  static Location = [];
  // static setLogininfo(data){
  //   Common.login_info=data;


  // }
  // static getLogininfo(data){
  //   if(Common.login_info){
  //     return Common.login_info;
  //   }else{

  //   }

  // }

  static School_Section = [];
  static login_info: any = "";
  static sub_section: any = "";
  static home_selec_menu = ["/user/home"
    , "/user/sub-section", "/user/ch_assessment", "/user/ch_assessment_entries", "/user/ch_sel_assessment", "/user/week-list", "/user/week-info", "/user/mainarea", "/user/mainsession"];

  // static load(){
  //   let  slideConfig: any = {
  //     dots: true,
  //     //speed: 300,
  //     slidesToShow: 1,
  //     slidesToScroll: 1,
  //     arrows: false,
  //     autoplay: false
  //    // infinite: false
  //   };
  //   (<any>$('.carss')).slick(slideConfig);
  // };
  static isDevice = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  static ShowBottom(show) {
    if (Common.isDevice) {
      if (!show) {
        Common._$("#divBFooter").addClass("hide");
      } else {
        Common._$("#divBFooter").removeClass("hide");
      }
    }

  }
  static pc_auth = "";
  static _$ = $;
  static staff_id = 1;
  static groupBy(xs, _key, name, color_code = "", add_area_field = false) {
    //Common.log("callgroupBy ")
    let dist_json = [];
    xs.map((x) => {
      let fltr = dist_json.filter((y) => { return y.id == x[_key]; });
      // Common.log("fltr",fltr)
      if (x[_key] && fltr.length == 0) {
        if (color_code) {
          if (add_area_field)
            dist_json.push({ id: x[_key], name: x[name], color_code: x[color_code], values: [], area_name: x.area_name, area_id: x.area_id });
          else
            dist_json.push({ id: x[_key], name: x[name], color_code: x[color_code], values: [] });
        } else {
          if (add_area_field)
            dist_json.push({ id: x[_key], name: x[name], color_code: "", values: [], area_name: x.area_name, area_id: x.area_id });
          else
            dist_json.push({ id: x[_key], name: x[name], color_code: "", values: [] });
        }
      }

    })

    dist_json.map((x) => {
      xs.map((y) => {
        if (x.id == y[_key]) {
          x.values.push(y);
        }
      })
    })
    return dist_json;
  };
  static groupByv2(xs, _key, name, icon, color_code = "", values_orderby = "") {
    let dist_json = { area: [{ key: "All Area", id: 0, active: true }], data: [] };

    xs.map((x) => {
      let fltr = dist_json.data.filter((y) => { return y.id == x[_key]; });
      // Common.log("fltr",fltr)
      if (x[_key] && fltr.length == 0)
        dist_json.data.push({ id: x[_key], name: x[name], color_code: x[color_code], values: [], icon_image: x[icon] });
    })

    dist_json.data.map((x) => {
      xs.map((y) => {
        if (x.id == y[_key]) {
          let _v = x.values.filter((f) => f.id == y.id);
          if (_v.length == 0)
            x.values.push(y);
        }
        y.filter_show = true;
      })
      x.show = false;
      x.filter_show = true;
      if (values_orderby) {
        x.values = orderBy(x.values, [values_orderby], ['asc']);
      }
    })
    xs.map(x => {
      let fltr = dist_json.area.filter((y) => { return y.id == x.area_week_id; });
      // Common.log("fltr",fltr)
      if (x.area_name && fltr.length == 0)
        dist_json.area.push({ key: x.area_name, id: x.area_week_id, active: false });
    })

    return dist_json;
  };

  static filterjso_areaid(xs, id) {
    //  Common.log("id",xs,id)
    if (id == 0) {
      xs.map((y) => {
        y.filter_show = true;
        y.values.map((x) => {
          x.filter_show = true;
        });
      });
    } else {

      xs.map((y) => {
        // Common.log("y",y)
        let flag = false;
        y.values.map((x) => {
          if (x.area_week_id == id) {
            flag = true; x.filter_show = true;
          } else {
            x.filter_show = false;
          }
        });
        if (flag) {
          y.filter_show = true;
        } else {
          y.filter_show = false;
        }
      });
    }
    return xs;
  }

  static cls_update(xs) {
    xs.map((currElement, index) => {
      switch (index % 3) {
        case 1:
          currElement.cls = "green_round_bg"; break;
        case 2:
          currElement.cls = "red_round_bg"; break;
        case 0:
          currElement.cls = "yellow_round_bg"; break;
      }

      currElement.values.map((currElement1, index1) => {
        currElement1.success_load = false;
        switch (index1 % 3) {
          case 1:
            currElement1.cls = "green_txt"; break;
          case 2:
            currElement1.cls = "red_txt"; break;
          case 0:
            currElement1.cls = "yellow_txt"; break;
        }
      });
    });
    return xs;
  }


  static scrollToTop(id) {

    let el = document.getElementById(id);
    //  el.scrollIntoView();

    //el.scrollIntoView(false);
    el.scrollIntoView({ behavior: 'smooth', block: 'center', });


  }

  static scrollToTop1(id) {

    let el = document.getElementById(id);
    //  el.scrollIntoView();

    //el.scrollIntoView(false);
    el.scrollIntoView({ behavior: 'smooth', block: 'start' });


  }

  static scrollToBottom(id) {

    let el = document.getElementById(id);
    //  el.scrollIntoView();
    // el.scrollIntoView({behavior: 'smooth', block: 'start'});
    el.scrollIntoView(true);


  }

  static tabfocusv3(index) {
    setTimeout(() => {
      if (Common.isDevice) {
        Common._$("#submain").animate({ scrollTop: Common._$("#submain").scrollTop() + Common._$("#divf_" + index).offset().top - 110 }, 500);
      } else {
        Common._$("#submain").animate({ scrollTop: Common._$("#submain").scrollTop() + Common._$("#divf_" + index).offset().top - 196 }, 500);
      }
    });
  }

  static PagecontainerInit(){
    Common._$('.container').css('min-height',((Common._$(window).height()))+'px');
    if( Common._$('#divinnerh').length>0)
    Common._$('#divinnerh').css('height',((Common._$(window).height())-76-93-74)+'px');
    Common._$(".container").animate({ scrollTop:0 }, 10);
  }
  static StarrTabfocus(id,_cat_id=0) {
    console.log("id",id)
    Common._$("#mtab" ).animate({ scrollTop: 0 }, 500)
    setTimeout(() => {
      if(id=="tab_deal")
      Common._$(".cdtc_top_btn" ).animate({ scrollLeft: 0 }, 500)
     else if(id=="tab_meetingHistory"){
      if(_cat_id==1)
      Common._$(".cdtc_top_btn" ).animate({ scrollLeft: 0 }, 500)
    else
    Common._$(".cdtc_top_btn" ).animate({ scrollLeft: 80 }, 500)
     }

      else {
        if(_cat_id==1)
        Common._$(".cdtc_top_btn" ).animate({ scrollLeft: 80 }, 500)
        else
        Common._$(".cdtc_top_btn" ).animate({ scrollLeft: 150 }, 500)
      }


      Common._$("#divcontainer").animate({ scrollTop: Common._$("#divcontainer").scrollTop() + Common._$("#" + id).offset().top - 100 }, 500);

    });
  }

  static Starrfocus(id) {
    setTimeout(() => {
      if (Common.isDevice) {
        Common._$("#divcontainer").animate({ scrollTop: Common._$("#divcontainer").scrollTop() + Common._$("#" + id).offset().top }, 500);
      } else {
        Common._$("#divcontainer").animate({ scrollTop: Common._$("#divcontainer").scrollTop() + Common._$("#" + id).offset().top - 86 }, 500);
      }
    });
  }

  static StarrPPfocus(id) {
    console.log("id",id)
    Common._$("#divpcontainer").animate({ scrollTop: Common._$("#divpcontainer").scrollTop() + Common._$("#" + id).offset().top - 230 }, 500);
  }
  static StarrPPfocus1(id) {
    console.log("id",id)
    if (Common.isDevice) {
      Common._$("#divcontainer").animate({ scrollTop: Common._$("#divcontainer").scrollTop() + Common._$("#" + id).offset().top- 120  }, 500);
    } else {
      Common._$("#divcontainer").animate({ scrollTop: Common._$("#divcontainer").scrollTop() + Common._$("#" + id).offset().top - 120 }, 500);
    }
  }


  static tabfocus(index) {

    setTimeout(() => {
      if (Common.isDevice) {
        Common._$("#submain").animate({ scrollTop: Common._$("#submain").scrollTop() + Common._$("#divf_" + index).offset().top - 230 }, 500);
      } else {
        Common._$("#submain").animate({ scrollTop: Common._$("#submain").scrollTop() + Common._$("#divf_" + index).offset().top - 310 }, 500);
      }

    });
  }
  static Topfocus() {

    setTimeout(() => {
      if (Common.isDevice) {
        Common._$("#divcontainer").animate({ scrollTop: 0 }, 500);
      } else {
        Common._$("#divcontainer").animate({ scrollTop: 0 }, 500);
      }

    });
  }

  static Sfocus(index) {

    setTimeout(() => {
      if (Common.isDevice) {
        Common._$("#divcontainer").animate({ scrollTop: Common._$("#divcontainer").scrollTop() + Common._$("#divf_" + index).offset().top - 230 }, 500);
      } else {
        Common._$("#divcontainer").animate({ scrollTop: Common._$("#divcontainer").scrollTop() + Common._$("#divf_" + index).offset().top - 310 }, 500);
      }

    });
  }

  static tabfocusv2(index) {

    setTimeout(() => {

      Common._$("#submain").animate({ scrollTop: Common._$("#submain").scrollTop() + Common._$("#divf_" + index).offset().top - 230 }, 500);
    });
  }
  // static Login_info ={
  //   school_name:"",
  //   mail:""
  // }
  //static _lodash = lodash;
  static openexternalurl(url) {
    if (Capacitor.platform === 'web') {
      window.open(url, "_system", "location=no");
    } else {
      if (Capacitor.platform == "ios") {
        window.open(url, "_system", "location=no");
      } else {
        navigator.app.loadUrl(url, { openExternal: true })
      }
    }
  };
  static Mail(to, subject, body, attachment = "") {

    // var email = $('#email').val();
    // var area = $('#area').val();
    // var body = $('#body').val();

    var mailto = 'mailto:' + to;
    var params = { subject: "", body: "", attachment: "" };

    if (subject) {
      params.subject = subject;
    }
    if (attachment) {
      params.attachment = attachment;
    }
    if (body) {
      var htmlHdrTxt = "<html><head></head><body>";
      var htmlFtrTxt = "</body></html>";
      var bodyTxt = htmlHdrTxt + body + htmlFtrTxt;
      params.body = (bodyTxt);
    }
    if (params) {
      mailto += '?' + $.param(params);
    }

    const WindowPrt = window.open(mailto, "_system", 'left=0,top=0,width=900,height=900,toolbar=0,scrollbars=0,status=0');
    //window.open('', '', 'left=0,top=0,width=900,height=900,toolbar=0,scrollbars=0,status=0');
    //  WindowPrt.document.write(content);
    //  WindowPrt.document.close();
    WindowPrt.focus();
    WindowPrt.close();
    setTimeout(() => {
      WindowPrt.close();
    }, 100);
    //this.openexternalurl(mailto);
  }
  static Set_height() {
    $('#divinner_container').css('height', (($(window).height())) + 'px');
    setTimeout(() => {
      $('#main_div').css('height', ($(window).height() - $("#div_head_card").height()) + 'px');
    });
    this.scrll_fixed_header();
  }

  static Set_height_with_footter() {
    setTimeout(() => {
      $('#main_div').css('height', ($(window).height() - ($("#div_head_card").height()) - 40) + 'px');
    });
  }
  static Set_height_with_footterv2(val) {
    setTimeout(() => {
      $('#main_div_' + val).css('height', ($(window).height() - ($("#div_head_card").height()) - 102) + 'px');
    });
  }

  static log(val) {
    console.log(val);
  }

  static scrll_fixed_header() {

    if ($('.sticky').length > 0) {
      document.addEventListener("scroll", function () {
        var secondToolbar = document.querySelector('.sticky');
        var map: any = document.querySelector('.map');

        if ((window.pageYOffset + 50) > (map.offsetTop + map.clientHeight))
          secondToolbar.classList.add('fixed');
        else
          secondToolbar.classList.remove('fixed');
      });

      // $('.sticky').scroll(function (){
      //   if ($('.sticky').scrollTop() == 0) {
      //     $('.sticky').addClass('fixed');
      //    }
      //    else {
      //     $('.sticky').removeClass('fixed');
      //    }
      // });
    }
  }

  static activity_groupBy(xs, _key, name) {
    //Common.log("callgroupBy ")
    let dist_json = [];
    xs.map((x) => {
      let fltr = dist_json.filter((y) => { return y.id == x[_key]; });
      let gfltr = dist_json.filter((y) => { return y.id == x[_key]; });
      if (x[_key] && fltr.length == 0) {
        dist_json.push({
          filter_show: true, id: x[_key], name: x[name], values: [], session_name: x.session_name, instruction: x.instruction, text: x.text, group_icon_image: x.group_icon_image, group_name: x.group_name, group_id: x.group_id
          , file_type: x.file_type, file_path: x.file_path, downloadable: x.downloadable, printable: x.printable
        });
      }
    })

    // downloadable: "1"
    // file_path: "https://nurseryrhymescollections.com/audio/abcdefg-the-alphabet-song.mp3"
    // file_type: 3
    // filter_show: true
    // id: 3
    // name: "Line Walking Game"
    // printable: 1
    // resource_from: "session"
    // resource_type_name: "Game"
    // session_id: 1
    // session_name: "Session 1"
    dist_json.map((x) => { xs.map((y) => { if (x.id == y[_key] && y.resource_name) { x.values.push(y); } }) })
    return dist_json;
  };

  static validateEmail(email) {
    const regularExpression = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return regularExpression.test(String(email).toLowerCase());
  }

  static getCurrentFinancialYear() {
    var today = new Date();
    var curMonth = today.getMonth(); // 0-based: 0 is Jan, 3 is Apr
    var fiscalYear = "";

    if (curMonth < 3) { // Before April
        fiscalYear = (today.getFullYear() - 1) + "-" + today.getFullYear();
    } else { // April or later
        fiscalYear = today.getFullYear() + "-" + (today.getFullYear() + 1);
    }
    return fiscalYear;
}

}
export class logger
{
    static oldConsoleLog = null;
    static pub = {};

    static enableLogger()
                        {
                            if(this.oldConsoleLog == null)
                                return;

                            window['console']['log'] = this.oldConsoleLog;
                        };

                        static disableLogger()
                        {
                           this. oldConsoleLog = console.log;
                            window['console']['log'] = function() {};
                        };
                        static sever_log(val){
                         this.enableLogger();
                          console.log(val)
                          this.disableLogger();

                        }


}



